import { Component, inject, input, output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ErrorModel } from '~api/models/error.model';
import { CredentialService } from '~api/services/credential.service';
import { RedemptionInfo } from '~app/types/redemption-info';
import { CredentialRedeemMfaRecipientDto } from '~generated-api/models/credential-redeem-mfa-recipient-dto';

@Component({
  selector: 'app-mfa',
  imports: [
    TranslateModule,
    ReactiveFormsModule
  ],
  templateUrl: './mfa.html',
  styleUrl: './mfa.css',
})
export class Mfa {
  readonly credentialKey = input.required<string>();
  readonly redemptionInfo = output<RedemptionInfo>();
  protected requestState: 'new' | 'requesting' | 'requested' | 'verifying' | 'error' | 'failed' = 'new';
  protected recipient?: CredentialRedeemMfaRecipientDto;
  protected form = new FormGroup({
    token: new FormControl('', [Validators.required, Validators.maxLength(6), Validators.minLength(6)])
  });
  private readonly credential = inject(CredentialService);
  private credentialId?: string;

  onRequestMfa() {
    this.requestState = 'requesting';
    this.form.reset();
    this.credential.initiateCredentialRedemption(this.credentialKey()).subscribe((res) => {
      if (res instanceof ErrorModel) {
        this.requestState = 'error';
      } else {
        this.requestState = 'requested';

        if ('id' in res) {
          this.credentialId = res.id;
          this.recipient = ('recipient' in res) ? res.recipient : undefined;
          this.redemptionInfo.emit({
            id: res.id,
            status: res.status,
            types: ('types' in res) ? res.types : undefined,
            result: res
          });
        }
      }
    });
  }

  onVerifyMfa() {
    if (!this.credentialId || this.form.invalid) {
      return;
    }

    this.requestState = 'verifying';
    this.credential.verifyCredentialRedemption(this.credentialId, this.form.value.token!).subscribe((res) => {
      if (res instanceof ErrorModel) {
        if (res.errorCode === '400.001.008' || res.errorCode === '400.401.006') {
          this.requestState = 'failed';
        } else {
          this.requestState = 'error';
        }
      } else {
        if ('id' in res) {
          this.redemptionInfo.emit({
            id: res.id,
            status: res.status,
            types: ('types' in res) ? res.types : undefined,
            result: res
          });
        }
      }
    });
  }
}
